import React from 'react'
import './Info.css'
export default function Info({msg,handleInfo}) {
  return (
    <div className="container-info">
      <p>{msg}</p>
      <i onClick={handleInfo} className="fa-solid fa-xmark"></i>
    </div>
  )
}
